export interface BaseMbListJson {
  id: string; // 标识id
  name: string; // 路由name
  path: string; // 路由path
  isOldHead?: boolean; // 是否老版头部
  isUmeng?: string; // 需要Umeng
  azLink?: string; // 需要下载az
  iosInstall?: any[];
  iosLink?: string; // 需要下载ios
  isSguic?: string[]; // 下载需要sguic
  isSigmob?: true; // 是否调用sigmob
  topOne?: string; // 是否需要顶部第一行
  topTwo?: string; // 是否需要顶部第二行
  topThree?: string; // 是否需要顶部第三行
  linkText?: string;
  linkList?: number[]; // 底部链接数组
  bottomTwo?: string; // 是否需要底部第二行
  bottomThree?: string; // 是否需要底部第三行
  bottomFour?: string; // 是否需要底部第四行
  bottomFive?: string; // 是否需要底部第五行
  isNewSwiper?: boolean;
  isProduction?: boolean;
  isWxModal?: boolean; // 是否需要开启微信打开引导蒙版
  wxModalMobile?: string; // 是否需要进行设备区分
}

export const baseMbList: BaseMbListJson[] = [
  {
    id: "1001",
    name: "yx3605",
    path: "/yx3605",
    azLink: "//static.dhsf.996box.com/box/channel_app/1677665301000_k58KE.apk",
    topOne: "996传奇盒子",
    topTwo: "版本号：2.4.0 更新时间：2023-01-12",
    topThree: "开发者：浙江闲趣互娱网络科技有限公司",
    linkList: [4],
    bottomTwo: "开发者：浙江闲趣互娱网络科技有限公司",
    bottomThree: "成都玖壹玩网络科技有限公司",
    bottomFour: "应用名称：996传奇盒子 版本号：2.4.0 更新时间：2023-01-12",
  },
  {
    id: "1002",
    name: "sougou3",
    path: "/sougou3",
    azLink: "//static.dhsf.xqhuyu.com/box/channel_app/1673506012000_2nnC6.apk",
    iosLink:
      "//www.996box.com?id=JmKZUGIt&game_id=-1&img_template_id=1&channel_id=11228",
    topOne: "996传奇盒子",
    topTwo: "版本号：2.4.0 更新时间：2023-01-12",
    topThree: "开发者：浙江闲趣互娱网络科技有限公司",
    linkList: [4],
    bottomTwo: "山西乐享网络科技有限公司版权所有©2021-2022",
    bottomThree: "开发者：浙江闲趣互娱网络科技有限公司 版本号：2.4.0",
    isNewSwiper: true,
  },
  {
    id: "1003",
    name: "sougou2",
    path: "/sougou2",
    azLink: "//static.dhsf.xqhuyu.com/box/channel_app/1673506166000_NXysy.apk",
    isSguic: ["track", "DOWNLOAD_BUTTON_CLICK", "2729969"],
    topOne: "996传奇盒子",
    topTwo: "版本号：2.4.0 更新时间：2023-01-12",
    topThree: "开发者：浙江闲趣互娱网络科技有限公司",
    linkList: [4],
    bottomTwo: "海南瀚动网络科技有限公司版权所有©2021-2022",
    bottomThree: "开发者：浙江闲趣互娱网络科技有限公司 版本号：2.4.0",
    isNewSwiper: true,
  },
  {
    id: "1004",
    name: "ibaidu2",
    path: "/ibaidu2",
    azLink:
      "//m.996box.com/ios/toAppStore.html?id=N3ISWrsO&game_id=-1&img_template_id=1&channel_id=15158&key=y7jgc7",
    topOne: "996传奇盒子",
    topTwo: "版本号：2.7.2 更新时间：2022-10-20",
    topThree: "开发者：浙江闲趣互娱网络科技有限公司",
    linkList: [4],
    bottomTwo: "开发者：浙江闲趣互娱网络科技有限公司",
    bottomThree: "上海跃客网络科技有限公司",
    bottomFour: "应用名称：996传奇盒子 版本号：2.7.2 更新时间：2022-10-20",
    isNewSwiper: true,
  },
  {
    id: "1005",
    name: "ibaidu",
    path: "/ibaidu",
    azLink:
      "//m.996box.com/ios/toAppStore.html?id=u03oEqRY&game_id=-1&&img_template_id=1&channel_id=11943",
    topOne: "996传奇盒子",
    topTwo: "版本号：2.7.2 更新时间：2022-10-14",
    topThree: "开发者：浙江闲趣互娱网络科技有限公司",
    linkList: [4],
    bottomTwo: "开发者：浙江闲趣互娱网络科技有限公司",
    bottomThree: "上海跃客网络科技有限公司",
    bottomFour: "应用名称：996传奇盒子 版本号：2.7.2 更新时间：2022-10-14",
  },
  {
    id: "1006",
    name: "msougou2",
    path: "/msougou2",
    azLink: "//static.dhsf.xqhuyu.com/box/channel_app/1663122355000_bpWxm.apk",
    topOne: "996传奇盒子",
    topTwo: "版本号：1.8.2 更新时间：2022-08-15",
    topThree: "开发者：浙江闲趣互娱网络科技有限公司",
    linkList: [4],
    bottomTwo: "开发者：浙江闲趣互娱网络科技有限公司",
    bottomThree: "南昌尔雅网络有限公司",
    bottomFour: "应用名称：996传奇盒子 版本号：1.8.2 更新时间：2022-08-15",
  },
  {
    id: "1007",
    name: "uc4",
    path: "/uc4",
    azLink: "//static.dhsf.996box.com/box/channel_app/1675234538000_tFNNH.apk",
    topOne: "996传奇盒子",
    topTwo: "版本号：2.4.0 更新时间：2023-01-12",
    topThree: "开发者：浙江闲趣互娱网络科技有限公司",
    linkList: [4],
    bottomTwo: "开发者：浙江闲趣互娱网络科技有限公司",
    bottomThree: "成都柒玖游科技有限公司",
    bottomFour: "应用名称：996传奇盒子 版本号：2.4.0 更新时间：2023-01-12",
  },
  {
    id: "1008",
    name: "uc3",
    path: "/uc3",
    azLink: "//static.dhsf.xqhuyu.com/box/channel_app/1670817217000_DQa6n.apk",
    topOne: "996传奇盒子",
    topTwo: "版本号：2.2.0 更新时间：2022-12-09",
    topThree: "开发者：浙江闲趣互娱网络科技有限公司",
    linkList: [4],
    bottomTwo: "开发者：浙江闲趣互娱网络科技有限公司",
    bottomThree: "成都柒玖游科技有限公司",
    bottomFour: "应用名称：996传奇盒子 版本号：2.2.0 更新时间：2022-12-09",
    isNewSwiper: true,
  },
  {
    id: "1009",
    name: "uc2",
    path: "/uc2",
    azLink: "//static.dhsf.xqhuyu.com/box/channel_app/1662447651000_b6nHc.apk",
    iosLink:
      "//www.996box.com?id=VMLzG7Ax&game_id=-1&img_template_id=1&channel_id=11270",
    topOne: "996传奇盒子",
    topTwo: "版本号：1.8.2 更新时间：2022-08-15",
    topThree: "开发者：浙江闲趣互娱网络科技有限公司",
    linkList: [4],
    bottomTwo: "开发者：浙江闲趣互娱网络科技有限公司",
    bottomThree: "成都柒玖游科技有限公司",
    bottomFour: "应用名称：996传奇盒子 版本号：1.8.2 更新时间：2022-08-15",
    isNewSwiper: true,
  },
  {
    id: "1010",
    name: "uc",
    path: "/uc",
    isOldHead: true,
    isUmeng: "62afdea888ccdf4b7e9ff6f3",
    azLink: "//static.dhsf.996box.com/box/channel_app/1703485026000_iTNX3.apk",
    iosLink: "//apps.apple.com/cn/app/%E5%A5%87%E6%B8%B8%E7%A4%BE/id6502948709",
    linkText: "隐私政策",
    linkList: [0, 1, 2, 3, 4],
    bottomTwo: "浙ICP备18047431号-5｜浙网文〔2018〕8788-693号",
    bottomThree: "增值电信业务经营许可证：浙B2-20181229",
    bottomFour: "浙江闲趣互娱网络科技有限公司版权所©2021-2022",
    isNewSwiper: true,
  },
  {
    id: "1011",
    name: "zdzm",
    path: "/zdzm",
    isOldHead: true,
    azLink: "//static.dhsf.xqhuyu.com/temporary_file/1657700429000_m6nnQ.apk",
    iosInstall: [401, "shcwe3"],
    linkText: "隐私政策",
    linkList: [0, 1, 2, 3, 4],
    bottomTwo: "浙ICP备18047431号-5｜浙网文〔2018〕8788-693号",
    bottomThree: "增值电信业务经营许可证：浙B2-20181229",
    bottomFour: "浙江闲趣互娱网络科技有限公司版权所©2021-2022",
  },
  {
    id: "1012",
    name: "wm",
    path: "/wm",
    isOldHead: true,
    azLink: "//static.dhsf.xqhuyu.com/temporary_file/1657700489000_XFsBD.apk",
    iosInstall: [401, "shcwe3"],
    linkText: "隐私政策",
    linkList: [0, 1, 2, 3, 4],
    bottomTwo: "浙ICP备18047431号-5｜浙网文〔2018〕8788-693号",
    bottomThree: "增值电信业务经营许可证：浙B2-20181229",
    bottomFour: "浙江闲趣互娱网络科技有限公司版权所©2021-2022",
  },
  {
    id: "1013",
    name: "msougou1",
    path: "/msougou1",
    isOldHead: true,
    azLink: "//static.dhsf.xqhuyu.com/temporary_file/1658453539000_atDHp.apk",
    iosInstall: [401, "c3nvhp"],
    linkText: "权限&隐私政策",
    linkList: [0, 1, 2, 3, 4],
    bottomTwo: "浙ICP备18047431号-5｜浙网文〔2018〕8788-693号",
    bottomThree: "增值电信业务经营许可证：浙B2-20181229",
    bottomFour: "山西乐享网络科技有限公司版权所有©2021-2022",
    bottomFive: "开发者：浙江闲趣互娱网络科技有限公司 版本号：1.6.4",
  },
  {
    id: "1014",
    name: "m996",
    path: "/m996",
    isOldHead: true,
    azLink: "//static.dhsf.996box.com/box/channel_app/1676005329000_8m3SG.apk",
    iosLink:
      "https://apps.apple.com/cn/app/996%E4%BC%A0%E5%A5%87%E7%9B%92%E5%AD%90-%E4%BC%A0%E5%A5%87%E6%B8%B8%E6%88%8F%E7%8E%A9%E6%9C%8D%E7%A4%BE%E5%8C%BA/id1619056696",
    linkText: "隐私政策",
    linkList: [0, 1, 2, 3, 4],
    bottomTwo: "浙ICP备18047431号-5｜浙网文〔2018〕8788-693号",
    bottomThree: "增值电信业务经营许可证：浙B2-20181229",
    bottomFour: "浙江闲趣互娱网络科技有限公司版权所©2021-2022",
  },
  {
    id: "1015",
    name: "msougou",
    path: "/msougou",
    isOldHead: true,
    azLink: "//static.dhsf.996box.com/box/channel_app/1673507223000_FywbJ.apk",
    iosLink: "//apps.apple.com/cn/app/%E5%A5%87%E6%B8%B8%E7%A4%BE/id6502948709",
    linkText: "隐私政策",
    linkList: [0, 1, 2, 3, 4],
    bottomTwo: "浙ICP备18047431号-5｜浙网文〔2018〕8788-693号",
    bottomThree: "增值电信业务经营许可证：浙B2-20181229",
    bottomFour: "浙江闲趣互娱网络科技有限公司版权所©2021-2022",
    isNewSwiper: true,
  },
  {
    id: "1016",
    name: "360m/001",
    path: "/360m/001",
    isOldHead: true,
    azLink:
      "//www.996box.com?id=V7h6cMrW&game_id=-1&img_template_id=1&channel_id=11450",
    linkText: "隐私政策",
    linkList: [0, 1, 2, 3, 4],
    bottomTwo: "浙ICP备18047431号-5｜浙网文〔2018〕8788-693号",
    bottomThree: "增值电信业务经营许可证：浙B2-20181229",
    bottomFour: "浙江闲趣互娱网络科技有限公司版权所©2021-2022",
  },
  {
    id: "1017",
    name: "kuaishou",
    path: "/kuaishou",
    azLink: "//static.dhsf.xqhuyu.com/box/channel_app/1670832841000_8B7px.apk",
    iosLink:
      "//apps.apple.com/cn/app/996%E4%BC%A0%E5%A5%87%E6%89%8B%E6%B8%B8-%E4%BC%A0%E5%A5%87%E6%B8%B8%E6%88%8F%E7%8E%A9%E6%9C%8D%E7%A4%BE%E5%8C%BA/id1621244973",
    topOne: "996传奇盒子",
    topTwo: "版本号：2.2.0 更新时间：2022-12-09",
    topThree: "开发者：浙江闲趣互娱网络科技有限公司",
    linkText: "权限&隐私政策",
    linkList: [4],
    bottomTwo: "开发者：浙江闲趣互娱网络科技有限公司 版本号：2.2.0",
  },
  {
    id: "1018",
    name: "wangyiyixiao",
    path: "/wangyiyixiao",
    isOldHead: true,
    azLink: "//static.dhsf.xqhuyu.com/box/channel_app/1665562132000_4ZSBb.apk",
    linkText: "隐私政策",
    linkList: [0, 1, 2, 3, 4],
    bottomTwo: "浙ICP备18047431号-5｜浙网文〔2018〕8788-693号",
    bottomThree: "增值电信业务经营许可证：浙B2-20181229",
    bottomFour: "浙江闲趣互娱网络科技有限公司版权所©2021-2022",
  },
  {
    id: "1019",
    name: "dxaiqiyi",
    path: "/dxaiqiyi",
    isOldHead: true,
    azLink: "//static.dhsf.xqhuyu.com/box/channel_app/1666338407000_trrGC.apk",
    linkText: "隐私政策",
    linkList: [0, 1, 2, 3, 4],
    bottomTwo: "浙ICP备18047431号-5｜浙网文〔2018〕8788-693号",
    bottomThree: "增值电信业务经营许可证：浙B2-20181229",
    bottomFour: "浙江闲趣互娱网络科技有限公司版权所©2021-2022",
  },
  {
    id: "1020",
    name: "jyaiqiyi",
    path: "/jyaiqiyi",
    isOldHead: true,
    azLink: "//static.dhsf.xqhuyu.com/box/channel_app/1666590447000_khPiC.apk",
    linkText: "隐私政策",
    linkList: [0, 1, 2, 3, 4],
    bottomTwo: "浙ICP备18047431号-5｜浙网文〔2018〕8788-693号",
    bottomThree: "增值电信业务经营许可证：浙B2-20181229",
    bottomFour: "浙江闲趣互娱网络科技有限公司版权所©2021-2022",
  },
  {
    id: "1021",
    name: "jiayinwangyiyunyinyue",
    path: "/jiayinwangyiyunyinyue",
    isOldHead: true,
    azLink: "//static.dhsf.xqhuyu.com/box/channel_app/1666332719000_3Mc7j.apk",
    linkText: "隐私政策",
    linkList: [0, 1, 2, 3, 4],
    bottomTwo: "浙ICP备18047431号-5｜浙网文〔2018〕8788-693号",
    bottomThree: "增值电信业务经营许可证：浙B2-20181229",
    bottomFour: "浙江闲趣互娱网络科技有限公司版权所©2021-2022",
  },
  {
    id: "1022",
    name: "jiayinwangyixinwen",
    path: "/jiayinwangyixinwen",
    isOldHead: true,
    azLink: "//static.dhsf.xqhuyu.com/box/channel_app/1666332564000_fS7pF.apk",
    linkText: "隐私政策",
    linkList: [0, 1, 2, 3, 4],
    bottomTwo: "浙ICP备18047431号-5｜浙网文〔2018〕8788-693号",
    bottomThree: "增值电信业务经营许可证：浙B2-20181229",
    bottomFour: "浙江闲趣互娱网络科技有限公司版权所©2021-2022",
  },
  {
    id: "1023",
    name: "360m",
    path: "/360m",
    isOldHead: true,
    azLink: "//static.dhsf.996box.com/box/channel_app/1673505643000_KD5Mw.apk",
    iosLink: "//apps.apple.com/cn/app/%E5%A5%87%E6%B8%B8%E7%A4%BE/id6502948709",
    linkText: "隐私政策",
    linkList: [0, 1, 2, 3, 4],
    bottomTwo: "浙ICP备18047431号-5｜浙网文〔2018〕8788-693号",
    bottomThree: "增值电信业务经营许可证：浙B2-20181229",
    bottomFour: "浙江闲趣互娱网络科技有限公司版权所©2021-2022",
    isNewSwiper: true,
  },
  {
    id: "1024",
    name: "sigmob1",
    path: "/sigmob1",
    isSigmob: true,
    iosLink:
      "https://m.996box.com/ios/toAppStore.html?id=T2qZxoMc&game_id=-1&&img_template_id=1&channel_id=13419",
    topOne: "996传奇盒子",
    topTwo: "版本号：2.7.7 更新时间：2023-03-01",
    topThree: "开发者：浙江闲趣互娱网络科技有限公司",
    linkList: [4],
    bottomTwo: "开发者：浙江闲趣互娱网络科技有限公司",
    bottomThree: "应用名称：996传奇盒子 版本号：2.7.7 更新时间：2023-03-01",
  },
  {
    id: "1025",
    name: "baidu9",
    path: "/baidu9",
    iosLink:
      "https://m.996box.com/ios/toAppStore.html?id=FtNorQBu&game_id=-1&img_template_id=1&channel_id=14181&key=jcte93",
    topOne: "996传奇盒子",
    topTwo: "版本号：2.8.0 更新时间：2023-03-14",
    topThree: "开发者：浙江闲趣互娱网络科技有限公司",
    linkList: [4],
    bottomTwo: "开发者：浙江闲趣互娱网络科技有限公司",
    bottomThree: "应用名称：996传奇盒子 版本号：2.8.0 更新时间：2023-03-14",
    isNewSwiper: true,
  },
  {
    id: "1026",
    name: "yykp",
    path: "/yykp",
    isOldHead: true,
    azLink: "//static.dhsf.996box.com/box/channel_app/1684991695000_hxtWK.apk",
    iosLink:
      "//apps.apple.com/cn/app/996%E4%BC%A0%E5%A5%87%E7%9B%92%E5%AD%90-%E4%BC%A0%E5%A5%87%E6%89%8B%E6%B8%B8%E7%8E%A9%E6%9C%8D%E6%B8%B8%E6%88%8F%E7%A4%BE%E5%8C%BA/id6444938453",
    linkText: "隐私政策",
    linkList: [0, 1, 2, 3, 4],
    bottomTwo: "浙ICP备18047431号-5｜浙网文〔2018〕8788-693号",
    bottomThree: "增值电信业务经营许可证：浙B2-20181229",
    bottomFour: "浙江闲趣互娱网络科技有限公司版权所©2021-2022",
  },
  {
    id: "1027",
    name: "yyzb",
    path: "/yyzb",
    isOldHead: true,
    azLink: "//static.dhsf.996box.com/box/channel_app/1684994509000_YjeaF.apk",
    iosLink:
      "//apps.apple.com/cn/app/996%E4%BC%A0%E5%A5%87%E7%9B%92%E5%AD%90-%E4%BC%A0%E5%A5%87%E6%89%8B%E6%B8%B8%E7%8E%A9%E6%9C%8D%E6%B8%B8%E6%88%8F%E7%A4%BE%E5%8C%BA/id6444938453",
    linkText: "隐私政策",
    linkList: [0, 1, 2, 3, 4],
    bottomTwo: "浙ICP备18047431号-5｜浙网文〔2018〕8788-693号",
    bottomThree: "增值电信业务经营许可证：浙B2-20181229",
    bottomFour: "浙江闲趣互娱网络科技有限公司版权所©2021-2022",
  },
  {
    id: "1028",
    name: "baidu11",
    path: "/baidu11",
    iosLink:
      "https://m.996box.com/ios/toAppStore.html?id=47tQs0PK&game_id=-1&img_template_id=1&channel_id=15112&key=y7jgc7",
    topOne: "996传奇盒子",
    topTwo: "版本号：2.8.9 更新时间：2023-03-15",
    topThree: "开发者：浙江闲趣互娱网络科技有限公司",
    linkList: [4],
    bottomTwo: "开发者：浙江闲趣互娱网络科技有限公司",
    bottomThree: "杭州心游网络科技有限公司",
    bottomFour: "应用名称：996传奇盒子 版本号：2.8.9 更新时间：2023-03-15",
    isNewSwiper: true,
  },
  {
    id: "1029",
    name: "baidu12",
    path: "/baidu12",
    iosLink:
      "https://m.996box.com/ios/toAppStore.html?id=u0r2EysZ&game_id=-1&img_template_id=1&channel_id=15511&key=y7jgc7",
    topOne: "996传奇盒子",
    topTwo: "版本号：2.8.9 更新时间：2023-03-15",
    topThree: "开发者：浙江闲趣互娱网络科技有限公司",
    linkList: [4],
    bottomTwo: "开发者：浙江闲趣互娱网络科技有限公司",
    bottomThree: "杭州心游网络科技有限公司",
    bottomFour: "应用名称：996传奇盒子 版本号：2.8.9 更新时间：2023-03-15",
    isNewSwiper: true,
  },
  {
    id: "1030",
    name: "yx3607",
    path: "/yx3607",
    azLink: "//static.dhsf.996box.com/box/channel_app/1694584429000_4ScJ8.apk",
    topOne: "996传奇盒子",
    topTwo: "版本号：3.2.0 更新时间：2023-08-23",
    topThree: "开发者：浙江闲趣互娱网络科技有限公司",
    linkList: [1, 4],
    bottomTwo: "开发者：浙江闲趣互娱网络科技有限公司",
    bottomThree: "成都玖壹玩网络科技有限公司",
    bottomFour: "应用名称：996传奇盒子 版本号：3.2.0 更新时间：2023-08-23",
    isNewSwiper: true,
    isProduction: true,
  },
  {
    id: "1031",
    name: "yx3606",
    path: "/yx3606",
    azLink: "//static.dhsf.996box.com/box/channel_app/1694584531000_ZaMYk.apk",
    topOne: "996传奇盒子",
    topTwo: "版本号：3.2.0 更新时间：2023-08-23",
    topThree: "开发者：浙江闲趣互娱网络科技有限公司",
    linkList: [1, 4],
    bottomTwo: "开发者：浙江闲趣互娱网络科技有限公司",
    bottomThree: "成都玖壹玩网络科技有限公司",
    bottomFour: "应用名称：996传奇盒子 版本号：3.2.0 更新时间：2023-08-23",
    isNewSwiper: true,
    isProduction: true,
  },
  {
    id: "1032",
    name: "uc1",
    path: "/uc1",
    iosLink:
      "//m.996box.com/ios/toAppStore.html?id=evcAuwEQ&game_id=-1&img_template_id=1&channel_id=15652&key=y7jgc7",
    topOne: "996传奇盒子",
    topTwo: "版本号：2.8.9 更新时间：2023-03-15",
    topThree: "开发者：浙江闲趣互娱网络科技有限公司",
    linkList: [1, 4],
    bottomTwo: "开发者：浙江闲趣互娱网络科技有限公司",
    bottomThree: "上海跃客网络科技有限公司",
    bottomFour: "应用名称：996传奇盒子 版本号：2.8.9 更新时间：2023-03-15",
    isNewSwiper: true,
    isProduction: true,
  },
  {
    id: "1033",
    name: "zb1",
    path: "/zb1",
    azLink: "//static.dhsf.996box.com/box/channel_app/1695719159000_HTbds.apk",
    iosLink:
      "//m.996box.com/ios/toAppStore.html?id=f5JESye7&game_id=-1&img_template_id=1&channel_id=15813&key=y7jgc7",
    topOne: "996传奇盒子",
    topTwo: "版本号：3.2.0 更新时间：2023-08-23",
    topThree: "开发者：浙江闲趣互娱网络科技有限公司",
    linkList: [1, 4],
    bottomTwo: "开发者：浙江闲趣互娱网络科技有限公司",
    bottomThree: "应用名称：996传奇盒子 版本号：3.2.0 更新时间：2023-08-23",
    isNewSwiper: true,
    isProduction: true,
  },
  {
    id: "1034",
    name: "zb2",
    path: "/zb2",
    azLink: "//static.dhsf.996box.com/box/channel_app/1695719364000_pT6EJ.apk",
    iosLink:
      "//m.996box.com/ios/toAppStore.html?id=HX8pgq9Q&game_id=-1&img_template_id=1&channel_id=15814&key=y7jgc7",
    topOne: "996传奇盒子",
    topTwo: "版本号：3.2.0 更新时间：2023-08-23",
    topThree: "开发者：浙江闲趣互娱网络科技有限公司",
    linkList: [1, 4],
    bottomTwo: "开发者：浙江闲趣互娱网络科技有限公司",
    bottomThree: "应用名称：996传奇盒子 版本号：3.2.0 更新时间：2023-08-23",
    isNewSwiper: true,
    isProduction: true,
  },
  {
    id: "1035",
    name: "zb3",
    path: "/zb3",
    azLink: "//static.dhsf.996box.com/box/channel_app/1695719546000_xJHfA.apk",
    iosLink:
      "//m.996box.com/ios/toAppStore.html?id=RD3TsIqM&game_id=-1&img_template_id=1&channel_id=15815&key=y7jgc7",
    topOne: "996传奇盒子",
    topTwo: "版本号：3.2.0 更新时间：2023-08-23",
    topThree: "开发者：浙江闲趣互娱网络科技有限公司",
    linkList: [1, 4],
    bottomTwo: "开发者：浙江闲趣互娱网络科技有限公司",
    bottomThree: "应用名称：996传奇盒子 版本号：3.2.0 更新时间：2023-08-23",
    isNewSwiper: true,
    isProduction: true,
  },
  {
    id: "1036",
    name: "zb4",
    path: "/zb4",
    azLink: "//static.dhsf.996box.com/box/channel_app/1695719709000_Jni7p.apk",
    iosLink:
      "//m.996box.com/ios/toAppStore.html?id=YFzC1dx9&game_id=-1&img_template_id=1&channel_id=15816&key=y7jgc7",
    topOne: "996传奇盒子",
    topTwo: "版本号：3.2.0 更新时间：2023-08-23",
    topThree: "开发者：浙江闲趣互娱网络科技有限公司",
    linkList: [1, 4],
    bottomTwo: "开发者：浙江闲趣互娱网络科技有限公司",
    bottomThree: "应用名称：996传奇盒子 版本号：3.2.0 更新时间：2023-08-23",
    isNewSwiper: true,
    isProduction: true,
  },
  {
    id: "1037",
    name: "zb5",
    path: "/zb5",
    azLink: "//static.dhsf.996box.com/box/channel_app/1695719967000_d8sHA.apk",
    iosLink:
      "//m.996box.com/ios/toAppStore.html?id=rHn0aEmW&game_id=-1&img_template_id=1&channel_id=15817&key=y7jgc7",
    topOne: "996传奇盒子",
    topTwo: "版本号：3.2.0 更新时间：2023-08-23",
    topThree: "开发者：浙江闲趣互娱网络科技有限公司",
    linkList: [1, 4],
    bottomTwo: "开发者：浙江闲趣互娱网络科技有限公司",
    bottomThree: "应用名称：996传奇盒子 版本号：3.2.0 更新时间：2023-08-23",
    isNewSwiper: true,
    isProduction: true,
  },
  {
    id: "1038",
    name: "uc5",
    path: "/uc5",
    azLink: "//static.dhsf.996box.com/box/channel_app/1705913063000_j3dr3.apk",
    topOne: "996传奇盒子",
    topTwo: "版本号：2.4.0 更新时间：2023-01-12",
    topThree: "开发者：浙江闲趣互娱网络科技有限公司",
    linkList: [4],
    bottomTwo: "开发者：浙江闲趣互娱网络科技有限公司",
    bottomThree: "成都柒玖游科技有限公司",
    bottomFour: "应用名称：996传奇盒子 版本号：2.4.0 更新时间：2023-01-12",
  },
  {
    id: "1039",
    name: "fsbd4",
    path: "/fsbd4",
    azLink:
      "//m.996box.com/ios/toAppStore.html?id=423TeXkF&game_id=-1&img_template_id=1&channel_id=17031&key=d22s18",
    iosLink:
      "//m.996box.com/ios/toAppStore.html?id=423TeXkF&game_id=-1&img_template_id=1&channel_id=17031&key=d22s18",
    topOne: "996传奇盒子",
    topTwo: "版本号：3.5.1 更新时间：2024-01-09",
    topThree: "开发者：浙江闲趣互娱网络科技有限公司",
    linkList: [1, 4],
    bottomTwo: "开发者：浙江闲趣互娱网络科技有限公司",
    bottomThree: "杭州心游网络科技有限公司",
    bottomFour: "应用名称：996传奇盒子 版本号：3.5.1 更新时间：2024-01-09",
    isNewSwiper: true,
    isProduction: true,
  },
  {
    id: "1040",
    name: "fengchaom",
    path: "/fengchaom",
    isOldHead: true,
    azLink: "//static.dhsf.996box.com/box/channel_app/1715321802000_kAPEy.apk",
    iosLink:
      "//apps.apple.com/cn/app/%E6%89%8B%E6%B8%B8%E4%BA%92%E5%8A%A8%E7%A4%BE%E5%8C%BA/id6451423580",
    linkText: "隐私政策",
    linkList: [0, 1, 2, 3, 4],
    bottomTwo: "浙ICP备18047431号-5｜浙网文〔2018〕8788-693号",
    bottomThree: "增值电信业务经营许可证：浙B2-20181229",
    bottomFour: "浙江闲趣互娱网络科技有限公司版权所©2021-2022",
    isNewSwiper: true,
  },
  {
    id: "1041",
    name: "baiduwangpan",
    path: "/baiduwangpan",
    isOldHead: true,
    azLink: "//static.dhsf.996box.com/box/channel_app/1718336618000_JJj2C.apk",
    iosLink: "//apps.apple.com/cn/app/%E5%A5%87%E6%B8%B8%E7%A4%BE/id6502948709",
    linkText: "隐私政策",
    linkList: [0, 1, 2, 3, 4],
    bottomTwo: "浙ICP备18047431号-5｜浙网文〔2018〕8788-693号",
    bottomThree: "增值电信业务经营许可证：浙B2-20181229",
    bottomFour: "浙江闲趣互娱网络科技有限公司版权所©2021-2022",
    isNewSwiper: true,
    isWxModal: true,
    wxModalMobile: "iPhone",
  },
  {
    id: "1042",
    name: "haokanshipin",
    path: "/haokanshipin",
    isOldHead: true,
    azLink: "//static.dhsf.996box.com/box/channel_app/1718355464000_RcwGm.apk",
    iosLink: "//apps.apple.com/cn/app/%E5%A5%87%E6%B8%B8%E7%A4%BE/id6502948709",
    linkText: "隐私政策",
    linkList: [0, 1, 2, 3, 4],
    bottomTwo: "浙ICP备18047431号-5｜浙网文〔2018〕8788-693号",
    bottomThree: "增值电信业务经营许可证：浙B2-20181229",
    bottomFour: "浙江闲趣互娱网络科技有限公司版权所©2021-2022",
    isNewSwiper: true,
    isWxModal: true,
    wxModalMobile: "iPhone",
  },
];
